// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3tHOj","detailBox":"_3svwB","detail":"_1QyKc","customFieldValue":"TYXxq","label":"_2h9yQ","custom":"_1arSl","mobile":"_1Avsz"};